// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_nFOPP {
    position: relative;
    min-height: inherit;
    height: 100%;
    width: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}

.container_nFOPP canvas {
    position: absolute;
    top: 0;
    left: 0;
}

.container_nFOPP video, .container_nFOPP canvas {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    object-fit: contain;
}

.scanBox_n8rmv {
    position: absolute;
    top: 30%;
    left: 10%;
    right: 10%;
    bottom: 30%;
    border: 4px solid rgba(254, 142, 19, 0.6);
}

.scanLine_Av5t9 {
    position: absolute;
    top: 50%;
    border: 1px solid rgba(255, 0, 0, 0.6);
    left: -50px;
    right: -50px;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-scanner-elements/lib/views/QuaggaScanner.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,sCAAsC;IACtC,WAAW;IACX,YAAY;AAChB","sourcesContent":[".container {\n    position: relative;\n    min-height: inherit;\n    height: 100%;\n    width: 100%;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.container canvas {\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.container video, .container canvas {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n    object-fit: contain;\n}\n\n.scanBox {\n    position: absolute;\n    top: 30%;\n    left: 10%;\n    right: 10%;\n    bottom: 30%;\n    border: 4px solid rgba(254, 142, 19, 0.6);\n}\n\n.scanLine {\n    position: absolute;\n    top: 50%;\n    border: 1px solid rgba(255, 0, 0, 0.6);\n    left: -50px;\n    right: -50px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_nFOPP`,
	"scanBox": `scanBox_n8rmv`,
	"scanLine": `scanLine_Av5t9`
};
export default ___CSS_LOADER_EXPORT___;
